import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Tags } from "lucide-react";
import CategorieViewDetails from "@/features/ventes/components/categories/CategorieView";

export const Route = createFileRoute("/_app/ventes/categories/$id/view")({
  loader: requirePermission(PERMISSIONS.VENTES.CATEGORIES.VIEW),
  staticData: {
    title: "Détails Catégorie",
    icon: Tags,
    showInBreadcrumb: true,
  },
  component: CategorieViewDetails,
});
